import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { findByUsuario } from './api-aluno-responsavel';
import { changeARAluno } from '../Usuario/api-usuario';
import { setUsuario } from '../Usuario/actions/actions';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Typography from '@mui/material/Typography';
import UserPhoto from '../../shared/assets/img/User.png'
import { useSelector, useDispatch } from 'react-redux';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import { Grid } from '@mui/material';
import { splitUtil } from '../../util/StringUtil';
import Loading from '../UI/Loading';

const useStyles = makeStyles(theme => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        // flex: '1 1 100%',
        // marginBottom: '20px',
        // marginTop: '20px'
    },
    arItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        margin: '20px',
        padding: '20px',
        alignItems: 'center',
    },
    arItemSelected: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        margin: '20px',
        padding: '20px',
        alignItems: 'center',
        backgroundColor: '#e3fbe3',
        borderRadius: '10%',
    }
}));

export default function AlunoResponsavelAtivoTable() {
    const classes = useStyles();
    const usuario = useSelector(state => state.usuario);
    const [alunosReponsavel, setAlunosReponsavel] = useState([]);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (usuario && usuario.id) {
            setIsLoading(true);
            findByUsuario(usuario.id).then((data) => {
                if (data) {
                    if (data.error) {
                        errorMessage(data.message);
                    } else {
                        setAlunosReponsavel(data);
                    }
                }

                setIsLoading(false);
            });
        }

    }, [usuario]);


    const handleAtivar = (aluno) => {
        changeARAluno(aluno).then((data) => {
            if (data) {
                dispatch(setUsuario(data));
                toast.success("Aluno Selecionado.", {
                    position: "bottom-left"
                });
            }
        });
    }

    return (
        <div>
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Typography className={classes.title} variant="h5">
                        Alunos
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <Container className={classes.paper} component={Paper}>
                        {isLoading ? <Loading style={{ marginTop: '20px' }} description='Carregando Alunos...' /> :
                            <>
                                {alunosReponsavel.length > 0 ?
                                    <>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            flexWrap: 'wrap',
                                            alignContent: 'center',
                                            justifyContent: 'flex-start',
                                            alignItems: 'flex-start',
                                        }}>
                                            {alunosReponsavel.map((ar) => (
                                                <div
                                                    key={ar.codigo}
                                                    className={
                                                        usuario && usuario.arAlunoSelecionado && usuario.arAlunoSelecionado.codigo === ar.aluno.codigo ?
                                                            classes.arItemSelected :
                                                            classes.arItem}
                                                >
                                                    {ar.alunoFoto ?
                                                        <img style={{
                                                            height: '120px',
                                                            borderRadius: '10%',
                                                        }} src={ar.alunoFoto.foto} alt='' />
                                                        :
                                                        <img
                                                            style={{
                                                                height: '200px',
                                                                borderRadius: '10%',
                                                            }}
                                                            src={UserPhoto}
                                                            alt=''
                                                        />
                                                    }
                                                    <p style={{
                                                        fontSize: '15px',
                                                        fontWeight: '800',
                                                    }}>{splitUtil(ar.aluno.nome, " ", 2)}</p>
                                                    {usuario && usuario.arAlunoSelecionado && usuario.arAlunoSelecionado.codigo === ar.aluno.codigo ?
                                                        <p>Selecionado</p> :
                                                        <Button
                                                            type="submit"
                                                            variant="contained"
                                                            color="secondary"
                                                            onClick={() => handleAtivar(ar.aluno)}
                                                        >
                                                            Selecionar
                                                        </Button>
                                                    }
                                                </div>
                                            ))}
                                        </div>
                                    </>


                                    : <p>Nenhum Aluno Cadastrado.</p>
                                }
                            </>

                        }

                    </Container>


                </Grid>
            </Grid>
        </div >
    );
}